import InvoicesService from "@/services/invoices.service.js";

import {
  INVOICES_LOADING,
  INVOICES_LOADED,
  RESET,
  RESET_PAGES,
  SET_ALL_INVOICES,
} from "./mutations";

import { validateAdminQueryParameter } from "./helpers";
import { INVOICE_LOAD_QUERY_PARAMETERS } from "../queryparams/page_load_query_params";
import { QUERY_PARAMETERS_ACTIONS } from "../queryparams";

export const GET_ALL_INVOICES = "getAllInvoices";
export const RESET_INVOICES = "resetInvoices";
export const PAGINATE_ALL_INVOICES = "paginateAllInvoices";
export const UPDATE_ALL_INVOICES = "updateAllInvoices";

export const actions = {
  [GET_ALL_INVOICES]({ commit, dispatch }, {page, slug, params}) {
    return new Promise((resolve, reject) => {
      commit(INVOICES_LOADING);
      commit(RESET_PAGES);
      dispatch(QUERY_PARAMETERS_ACTIONS.RESET_QUERY_PARAMS_WITH_FIRST_PAGE, {pageLoadVarsConstant: INVOICE_LOAD_QUERY_PARAMETERS, currentPageQueries: params})
      .then(({page, ...params}) => {
        return InvoicesService.getPaginatedPage(page, slug, params)
      })
      .then(({data, paginationData}) => {
        commit(SET_ALL_INVOICES, {data, paginationData});
        commit(INVOICES_LOADED);
        resolve(data);
      })
      .catch((error) => {
        commit(INVOICES_LOADED);
        reject(error);
      });
    });
  },
  [UPDATE_ALL_INVOICES]({commit, dispatch, state: {totalPages}}, {page, slug, params}) {
    let currentPath;
    ({currentPath, ...params} = params);
    commit(INVOICES_LOADING);
    return new Promise((resolve, reject) => {
      try {
        const payload = validateAdminQueryParameter(params, totalPages);
        dispatch(QUERY_PARAMETERS_ACTIONS.ADD_FILTER_QUERY_PARAMETER, {payload, currentPath})
        .then(({page, ...params}) => {
          return InvoicesService.getPaginatedPage(page, slug, params)
        })
        .then((response) => {
          commit(SET_ALL_INVOICES, response);
          commit(INVOICES_LOADED);
          resolve(response.data);
        })
        .catch((error) => {
          commit(INVOICES_LOADED);
          reject(error);
        });
      } catch(exp) {
        if(exp instanceof TypeError || exp instanceof RangeError ) {
          commit(INVOICES_LOADED);
          reject(exp);
        }
        throw exp;
      }
    });
  },
  [RESET_INVOICES]({ commit }) {
    commit(RESET);
  },
};
